var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _vm.includefilters === "true"
        ? _c("filter-sidebar", {
            attrs: {
              filters: _vm.filters,
              secondaryfilters: _vm.secondaryFilters
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "global-container" }, [
        _c("section", { staticClass: "section bg-white" }, [
          _c("div", { staticClass: "row" }, [
            _vm.sidebar !== null
              ? _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("side-menu", {
                      attrs: {
                        sidebar: _vm.sidebar,
                        hideChildren: _vm.sidebarHideChildren,
                        header: _vm.sidebarHeader
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.listing.length > 0
              ? _c(
                  "div",
                  { class: _vm.sidebar !== null ? "col-md-9" : "col-md-12" },
                  [
                    _c("section", { staticClass: "cards card--list" }, [
                      _c(
                        "div",
                        { staticClass: "global-container" },
                        [
                          _vm.body !== null
                            ? _c("div", [_c("body-content")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displaytype == "lungcast"
                            ? _vm._l(_vm.listing, function(item, index) {
                                return _c("podcast-item-lungcast", {
                                  key: item.DetailID,
                                  attrs: {
                                    item: item,
                                    displayDate: _vm.displayDate,
                                    displaySummary: _vm.displaySummary
                                  }
                                })
                              })
                            : _vm._l(_vm.listing, function(item, index) {
                                return _c("podcast-item", {
                                  key: item.DetailID,
                                  attrs: {
                                    item: item,
                                    displayDate: _vm.displayDate,
                                    displaySummary: _vm.displaySummary
                                  }
                                })
                              })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.listing.length > 0 && _vm.pagination.totalPages > 1
                      ? _c(
                          "section",
                          { staticClass: "padding-top padding-bottom" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [_c("pagination")],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.listing.length === 0 && _vm.includefilters === "true"
              ? _c("div", { staticClass: "col-md-9 align-center" }, [
                  _c("h2", { staticClass: "not-found-heading" }, [
                    _vm._v(
                      "Sorry, no items were found matching your specifications."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Try removing some filters or searching a different term."
                    )
                  ])
                ])
              : _vm.listing.length === 0
              ? _c("div", { staticClass: "col-md-9 align-center" }, [
                  _c("h2", { staticClass: "not-found-heading" }, [
                    _vm._v("Sorry, no items were found.")
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }